import styled from "styled-components";

/**
 * Wrapper do InputField (Mobile)
 * Configura o layout para ocupar 100% da largura em dispositivos móveis.
 */
export const InputFieldWrapperMobile = styled.div`
  align-items: center;
  position: relative;
  width: 100%;
  display: flex;

  & > div {
    width: 100%;
  }
`;

/**
 * Botão de limpar (Mobile)
 * Posicionado de forma responsiva para layouts menores.
 */
export const ClearButtonMobile = styled.button`
  background: ${({ theme }) => theme.colors.vividBlue};
  color: ${({ theme }) => theme.colors.white};
  font-size: ${({ theme }) => theme.fontSizes.xs};
  right: ${({ theme }) => theme.spacing(1)};
  transition: color 0.3s ease-in-out;
  align-items: center;
  position: relative;
  display: flex;
  border: none;
  cursor: pointer;

  & * {
    cursor: inherit;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.vividBlue};
  }

  &:focus {
    outline: none;
    color: ${({ theme }) => theme.colors.darkBlue};
  }

  &:disabled {
    color: ${({ theme }) => theme.colors.disabledGray};
    cursor: not-allowed;
  }
`;
